import LockPersonOutlinedIcon from '@mui/icons-material/LockPersonOutlined';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';

import { IconTypography } from 'reservations/base/components/IconTypography';

export const EvenSplitIconTypography = () => (
  <IconTypography
    dataTestId="even-split-icon-typography"
    icon={<ReceiptLongIcon />}
    text="The total bill will be split evenly"
  />
);

export const PrivatePaymentIconTypography = () => (
  <IconTypography
    dataTestId="private-payment-icon-typography"
    icon={<LockPersonOutlinedIcon />}
    text="Everyone's payment details, including gratuity, will remain private."
  />
);

interface Props {
  numberOfEnrolledGuests?: number;
}
export const GuestsEnrolledIconTypography = ({
  numberOfEnrolledGuests
}: Props) => (
  <IconTypography
    dataTestId="guests-enrolled-icon-typography"
    icon={<PersonOutlineOutlinedIcon />}
    text={`${numberOfEnrolledGuests} guest${numberOfEnrolledGuests === 1 ? ' is' : 's are'} currently enrolled`}
  />
);
